export default "__VITE_ASSET__035339ed__"